<template>
  <app-layout>
    <div class="bg-white shadow-lg px-4 py-8 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">
      <div class="flex flex-col flex-wrap items-center justify-center relative">

        <h2 class="mb-4">{{ $trans('app.test.catch-email-title') }}</h2>

        <p class="mb-6">{{ $trans('app.test.catch-email-subtitle') }}</p>

        <div class="w-full md:w-1/4 px-4">
          <jet-label for="email" :value="$trans('app.email')" class="font-bold"/>
          <jet-input id="email" type="text" class="mt-1 block w-full" v-model="form.email" autocomplete="first_name"/>
          <jet-input-error :message="form.errors.email" class="mt-2"/>
        </div>

        <bubble-button class="flex justify-center mt-8" @click="submitForm">{{
            $trans('app.see-results')
          }}
        </bubble-button>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import BubbleButton from '@/Components/BubbleButton';
import BackButton from '@/Components/BackButton';
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

export default {
  components: {AppLayout, BubbleButton, BackButton, JetLabel, JetInput, JetInputError},
  props: ['submission'],
  data() {
    return {
      form: this.$inertia.form({
        email: null,
      })
    }
  },

  methods: {
    submitForm() {
      console.log(this.submission)
      this.form.post(route('submission.addUser', this.submission))
    }
  }
}
</script>

<style>

</style>
